var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { StepType } from "@types";
import { findSourceById, getSelectedStepDetailsById, handleStepFieldValueChanges, registerStep, validateSource, validateStep, validateStepNameAndId } from "@utils";
import { FormSection } from "@components/FormSection/FormSection";
import { SourceSelectorInput } from "../SourceSelector/SourceSelectorInput";
import { AsyncButton, hasValue, TextArea } from "uxp/components";
import { getCustomTransformation } from "@query-engine-service";
import Icon from '@images/expand.svg';
import Copilot from '@images/copilot.svg';
import './CustomExpand.scss';
export function renderStep(context, query, onChange, selectedStepId) {
    const { step, index, previousSteps, selectedSources } = getSelectedStepDetailsById(query, selectedStepId);
    const _step = Object.assign({}, step);
    const $L = (key) => context.uxpContext.$L(key);
    const [errors, setErrors] = useState({});
    const [desc, setDesc] = useState('');
    useEffect(() => {
        const { isValid, errors } = validateStep(query, step);
        const resolved = Object.fromEntries(Object.entries(errors || {}).map(([k, v]) => [k, v && v.startsWith('lqe.') ? $L(v) : v]));
        setErrors(resolved);
        setDesc((step === null || step === void 0 ? void 0 : step.description) || '');
    }, [step]);
    function onValueChange(field, value, source) {
        return __awaiter(this, void 0, void 0, function* () {
            const _query = yield handleStepFieldValueChanges(context, query, selectedStepId, field, value, source);
            onChange(_query);
        });
    }
    const source = findSourceById(query, _step === null || _step === void 0 ? void 0 : _step.source);
    return React.createElement(React.Fragment, null,
        React.createElement(FormSection, { label: $L('lqe.step.expand.source'), error: errors === null || errors === void 0 ? void 0 : errors.source },
            React.createElement(SourceSelectorInput, { source: source, onChange: newSource => {
                    onValueChange('source', newSource, true);
                }, availableSources: [...previousSteps, ...selectedSources], query: query })),
        React.createElement(FormSection, { label: $L('lqe.step.expand.desc-label'), error: errors === null || errors === void 0 ? void 0 : errors.description },
            React.createElement("div", { className: "lqe-ce__content-5d218c73" },
                React.createElement("div", { className: "lqe-ce__input-row-5d218c73", title: _step.code },
                    React.createElement(TextArea, { value: desc || '', onChange: s => {
                            setDesc(s);
                        } }),
                    (!_step.code || desc != _step.description) && React.createElement(AsyncButton, { icon: Copilot, className: "lqe-ce__apply-btn-5d218c73", disabled: !hasValue(desc), onClick: () => __awaiter(this, void 0, void 0, function* () {
                            var _a, _b;
                            let r = yield getCustomTransformation(context, desc);
                            (_b = (_a = context.uxpContext).trackAnalytics) === null || _b === void 0 ? void 0 : _b.call(_a, 'custom-expand', {
                                message: desc,
                                success: true
                            });
                            onValueChange('description', desc);
                            onValueChange('code', r.code);
                            onValueChange('added', r.added || []);
                            onValueChange('removed', r.removed || []);
                        }), title: "Apply" })),
                React.createElement("div", { className: "lqe-ce__info-5d218c73" },
                    $L('lqe.step.expand.examples'),
                    React.createElement("ul", null,
                        React.createElement("li", null, "Add a new row for each month and add a field called 'month'"),
                        React.createElement("li", null, "expand the occupancy data for each room to include each hour of the day and add a field 'hour' with values from 0 to 23"))))));
}
function validate(query, step) {
    const errors = validateStepNameAndId(step);
    // validate source
    const source = validateSource(query, step, 'source');
    if (!source.isValid)
        errors.source = source.error;
    if (!hasValue(step.description))
        errors.description = 'lqe.step.expand.error-no-desc';
    if (!hasValue(step.code))
        errors.code = 'lqe.step.expand.error-unsaved';
    return {
        isValid: Object.keys(errors).length === 0,
        errors
    };
}
registerStep({
    type: StepType.CustomExpand,
    name: "lqe.step.expand.name",
    description: "lqe.step.expand.description",
    icon: Icon,
    iconStyles: {
        backgroundSize: '50%'
    },
    render: renderStep,
    validate: validate,
    onSelectStep: (basicProps, previousSource) => {
        return Object.assign(Object.assign({}, basicProps), { source: previousSource, description: '', code: '' });
    }
});
